import { useScreen, useGrid } from 'vue-screen';
import tailwindConfig from 'tailwind-config';

export const screen = useScreen();
export const grid = useGrid(tailwindConfig.theme.screens);
